import { observable } from 'mobx'

import SessionTableSelection, {
  ISessionSelectionTableCreatePayload,
} from './SessionSelectionTable'
import SessionTreeSelection, {
  ISessionSelectionTreeCreatePayload,
} from './SessionSelectionTree'

interface ISessionSelectionCreatePayload {
  table: ISessionSelectionTableCreatePayload
  tree: ISessionSelectionTreeCreatePayload
}

class SessionSelection {
  @observable table: SessionTableSelection
  @observable tree: SessionTreeSelection

  constructor(selection: ISessionSelectionCreatePayload) {
    this.table = new SessionTableSelection(selection.table)
    this.tree = new SessionTreeSelection(selection.tree)
  }
}

export default SessionSelection
